import { render, staticRenderFns } from "./LocationsOverview.vue?vue&type=template&id=6f139d38&scoped=true&"
import script from "./LocationsOverview.vue?vue&type=script&lang=js&"
export * from "./LocationsOverview.vue?vue&type=script&lang=js&"
import style0 from "./LocationsOverview.vue?vue&type=style&index=0&id=6f139d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f139d38",
  null
  
)

export default component.exports